import {
    useEffect, useMemo, useRef
} from 'react';

import { buildIdentityProps } from './identity';
import { useAnalyticsClient } from './use-analytics-client';
import { useQueryParams } from '../api/queries/certificate-reporting/use-fetcher';

export const useAnalyticsIdentity = () => {
    const client = useAnalyticsClient();
    const queryParams = useQueryParams();
    const identifiedRef = useRef(false);

    // `useQueryParams` builds a new URLSearchParams every render, and the
    // launch URL never changes for the life of the iframe, so resolve once.
    const identity = useMemo(
        () => buildIdentityProps(queryParams),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    useEffect(() => {
        if (identifiedRef.current || !client) return;

        identifiedRef.current = true;

        // Common props are set even without a profile id so an early
        // `page.time-on-page` is still attributed to app, env and locale.
        client.setCommonProps(identity);

        // The portal always supplies `userProfileId`. The guard is only so a
        // direct hit without it cannot alias every such session onto one
        // empty distinct id.
        if (identity.userProfileId) {
            client.identify();
        }
    }, [client, identity]);
};
